/** Editable artist directory. Full biographies remain readable without JavaScript. */
if (!customElements.get('bm-artists')) {
  customElements.define('bm-artists', class extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const { signal } = this.abortController;
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.querySelectorAll('[data-biography]').forEach((bio) => {
        bio.dataset.collapsed = 'true';
      });
      this.updateToggles = () => {
        this.querySelectorAll('[data-biography-toggle]').forEach((button) => {
          const bio = document.getElementById(button.getAttribute('aria-controls'));
          button.hidden = !bio || bio.children.length <= (this.mobile.matches ? 1 : 2);
        });
      };
      this.updateToggles();
      // Collapsing the biographies changes anchor positions on direct visits.
      const restoreArtistAnchor = () => {
        const artist = document.getElementById(window.location.hash.slice(1));
        if (artist && this.contains(artist)) artist.scrollIntoView({ block: 'start', behavior: 'instant' });
      };
      const restoreAfterLayout = () => requestAnimationFrame(() => {
        if (this.isConnected) restoreArtistAnchor();
      });
      if (document.readyState === 'complete') restoreAfterLayout();
      window.addEventListener('pageshow', restoreAfterLayout, { signal });
      this.mobile.addEventListener('change', this.updateToggles, { signal });
      this.addEventListener('click', (event) => {
        if (!(event.target instanceof Element)) return;
        const button = event.target.closest('[data-biography-toggle]');
        if (button) {
          const expanded = button.getAttribute('aria-expanded') !== 'true';
          const bio = document.getElementById(button.getAttribute('aria-controls'));
          if (!bio) return;
          bio.dataset.collapsed = String(!expanded);
          button.setAttribute('aria-expanded', String(expanded));
          const label = expanded ? button.dataset.collapseLabel : button.dataset.expandLabel;
          button.textContent = `${label} ${expanded ? '−' : '+'}`;
          button.setAttribute('aria-label', `${label}: ${button.dataset.artistName}`);
          if (!expanded) {
            // Keep the control in view after a long biography collapses, without
            // sending the reader back past the portrait to the top of the profile.
            const header = document.querySelector('header-component');
            const headerBottom = Math.max(0, header?.getBoundingClientRect().bottom || 0);
            const bounds = button.getBoundingClientRect();
            if (bounds.top < headerBottom + 16 || bounds.bottom > window.innerHeight) {
              button.scrollIntoView({ block: 'center', behavior: 'instant' });
            }
          }
          return;
        }
        const link = event.target.closest('a[href^="#artist-"]');
        if (link && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
          event.preventDefault();
          this.navigateToArtist(link.hash.slice(1));
        }
      }, { signal });
      this.addEventListener('change', (event) => {
        if (!(event.target instanceof HTMLSelectElement) || !event.target.matches('[data-artists-picker]')) return;
        if (event.target.value) {
          this.navigateToArtist(event.target.value);
        }
      }, { signal });
      this.addEventListener('shopify:block:select', (event) => {
        const profile = event.target.closest('.bm-artists__profile');
        profile?.scrollIntoView({ block: 'start', behavior: 'instant' });
      }, { signal });
    }
    navigateToArtist(id) {
      const artist = document.getElementById(id);
      if (!artist || !this.contains(artist)) return;
      if (window.location.hash !== `#${id}`) window.history.pushState(null, '', `#${id}`);
      artist.focus({ preventScroll: true });
      artist.scrollIntoView({
        block: 'start',
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
      });
    }
    disconnectedCallback() {
      this.abortController?.abort();
    }
  });
}
